module.exports = __webpack_public_path__ + "img/doc_1_full.6beb9acf.jpg";